import React, { useState } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import callingleads from "../../assets/images/life-time-rewards-format.csv";

const API_URL = process.env.REACT_APP_API_URL;

function AddsLifeTimeRewards() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
      confirmButtonText: "OK",
    });
  };

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  const validateForm = () => {
    if (!file) {
      Swal.fire({
        icon: "error",
        title: "No CSV File",
        text: "Please select a CSV file before submitting.",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error",
        );
        return;
      }

      const uploadData = new FormData();
      uploadData.append("lifetimerewardsCsv", file);

      const response = await fetch(`${API_URL}/life-time-offer-create-csv`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: uploadData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        showCustomMessageModal(
          "Error",
          errorData.message || "Failed to create Offer.",
          "error",
        );
        return;
      }

      const result = await response.json();
      if (result.success === "1") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: result.message,
          confirmButtonText: "OK",
        });

        setFile(null);

        setTimeout(() => {
          navigate("/all-offer-gifts");
        }, 2000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.message || "Something went wrong!",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      console.error("Error creating offer:", err);
      showCustomMessageModal(
        "Error",
        err.message || "An unexpected error occurred.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1600px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              🏅
            </div>
            <div style={{ flex: 1, minWidth: "220px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Upload Life Time Rewards
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Upload CSV file to create Life Time Rewards offers
              </p>
            </div>

            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    Download Life Time Rewards/Life Time Rewards Format
                  </Tooltip>
                }
              >
                <a
                  href={callingleads}
                  download="Lifetime Rewards Creation Format.csv"
                  style={{
                    padding: "12px 18px",
                    borderRadius: "12px",
                    border: "none",
                    background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "14px",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
                    textDecoration: "none",
                  }}
                >
                  ⬇ Download CSV
                </a>
              </OverlayTrigger>
            </div>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "24px" }}>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formFile">
                      <Form.Label
                        style={{
                          fontSize: "12.5px",
                          fontWeight: "700",
                          color: "#1e3a5f",
                          marginBottom: "6px",
                        }}
                      >
                        Upload CSV File <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".csv"
                        onChange={(e) => {
                          const selectedFile = e.target.files[0];
                          if (!selectedFile) return;

                          const fileExtension = selectedFile.name
                            .split(".")
                            .pop()
                            .toLowerCase();
                          if (fileExtension !== "csv") {
                            Swal.fire({
                              icon: "error",
                              title: "Invalid File",
                              text: "Only CSV files are allowed!",
                            });
                            e.target.value = null;
                            setFile(null);
                            return;
                          }
                          setFile(selectedFile);
                        }}
                      />
                      <Form.Text className="text-muted">
                        Please upload a CSV file in the correct format.
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>

                <div style={{ marginTop: "8px" }}>
                  <Button
                    type="submit"
                    disabled={loading}
                    style={{
                      borderRadius: "10px",
                      fontWeight: 700,
                      padding: "10px 24px",
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      border: "none",
                      color: "#ffffff",
                      boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
                    }}
                  >
                    {loading ? "Creating..." : "Upload New"}
                  </Button>
                </div>
              </Form>
            </div>
          </div>

          {/* Footer */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>
    </>
  );
}

export default AddsLifeTimeRewards;